<input
    [className]="'input-group__input input-datetime-picker__date ' + (inputFieldClass ?? '')"
    type="text"
    [(ngModel)]="value"
    (ngModelChange)="onValueChanged($event)"
    [placeholder]="placeholder"
/>
<label>{{ displayableDate }}</label>